export default __webpack_public_path__ + "538c53d223c9af955d3efcf19dc16ee0.glb";